import { CommonModule } from "@angular/common";
import { Component, computed, inject, signal } from "@angular/core";
import {
  ActivatedRoute,
  NavigationEnd,
  Router,
  RouterOutlet,
} from "@angular/router";
import { ModalService } from "../../../core/services/modal.service";
import { HelpDeskComponent } from "../../../features/support/help-desk/help-desk.component";
import { ModalComponent } from "@mlc/shared/modal/modal.component";
import { ProgressBarComponent } from "@mlc/shared/progress-bar/progress-bar.component";
import { filter } from "rxjs/operators";
import { Footer } from "../footer/footer";
import { Header } from "../header/header";
import { SidenavComponent } from "../sidenav/sidenav.component";
import { AuthService } from "../../../core/services/auth.service";
import { toSignal } from "@angular/core/rxjs-interop";
import { TailwindToastMessageComponent } from "@mlc/shared/toast-message/tailwind-toast-message/tailwind-toast-message.component";

@Component({
  selector: "app-main-layout",
  standalone: true,
  imports: [
    CommonModule,
    RouterOutlet,
    Header,
    Footer,
    ModalComponent,
    HelpDeskComponent,
    SidenavComponent,
    ProgressBarComponent,
    TailwindToastMessageComponent,
  ],
  templateUrl: "./main-layout.html",
})
export class MainLayout {
  private modalService: ModalService;
  isHelpDeskModalOpen = computed(() =>
    this.modalService.isHelpDeskModalOpen$(),
  );

  private router = inject(Router);
  private activatedRoute = inject(ActivatedRoute);
  private authService = inject(AuthService);

  private loggedInUser = toSignal(this.authService.getLoggedInUser());
  isAuthenticated = computed(() => {
    const user = this.loggedInUser();
    return user !== null && user !== undefined;
  });

  currentRouteUrl = signal<string>(this.router.url);

  showSidenav = computed(() => {
    const primaryRoute = this.currentRouteUrl().split("/")[1];
    return primaryRoute !== "case";
  });

  constructor(modalService: ModalService) {
    this.modalService = modalService;

    this.router.events
      .pipe(
        filter(
          (event): event is NavigationEnd => event instanceof NavigationEnd,
        ),
      )
      .subscribe((event: NavigationEnd) => {
        this.currentRouteUrl.set(event.urlAfterRedirects);
      });
  }

  closeHelpDeskModal() {
    this.modalService.closeHelpDeskModal();
  }
}
